import StageToMustFieldMappingTab from './stage-to-must-field-mapping';

export default StageToMustFieldMappingTab;
